module.exports = "/_next/static/images/virginia-ff0474fff2737db2d4dbad08fc3f391e.svg";